/**
 * Test A/B del mensaje del hero: «listo para tu ERP» (A) frente a «en un Excel
 * ordenado» (B).
 *
 * Por qué se mide así:
 * - La variante se asigna UNA vez por visitante y se guarda, para que quien
 *   vuelve vea siempre lo mismo.
 * - La métrica que decide no es un clic: es una prueba real del escáner. La
 *   variante viaja con la subida (`&v=`) y queda escrita en el resultado de
 *   DynamoDB (`demo_variant`), así que se puede contar aunque el visitante
 *   bloquee Google Analytics.
 * - Si el almacenamiento está bloqueado, el visitante ve A y NO cuenta como
 *   parte del test (variante «A-nostore»): mezclarlo sesgaría hacia A.
 */
const KEY = "ws_exp_hero";
export const HERO_EXPERIMENT = "hero_promise_v1";

let cached = null;

export function heroVariant() {
  if (cached) return cached;
  // Normalmente ya la decidió el script en línea de public/index.html.
  const pre = typeof document !== "undefined" && document.documentElement.getAttribute("data-hero");
  if (pre === "A" || pre === "B" || pre === "A-nostore") {
    cached = pre;
    return cached;
  }
  try {
    let v = localStorage.getItem(KEY);
    if (v !== "A" && v !== "B") {
      v = Math.random() < 0.5 ? "A" : "B";
      localStorage.setItem(KEY, v);
    }
    cached = v;
  } catch {
    cached = "A-nostore";
  }
  return cached;
}

/** «A» o «B» para elegir el texto; «A-nostore» se pinta como A. */
export function heroCopyVariant() {
  return heroVariant() === "B" ? "B" : "A";
}

let exposed = false;
/** Registra en GA4 que el visitante vio la variante (una vez por carga). */
export function trackHeroExposure() {
  if (exposed || typeof window === "undefined") return;
  exposed = true;
  try {
    window.gtag?.("event", "experiment_exposure", {
      experiment: HERO_EXPERIMENT,
      variant: heroVariant(),
    });
  } catch {
    /* sin GA no pasa nada */
  }
}
